import { render } from "./SpecialPageList.vue?vue&type=template&id=78b47a70"
import script from "./SpecialPageList.vue?vue&type=script&lang=js"
export * from "./SpecialPageList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__